var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeDiff > 0)?_c('div',{staticClass:"text-no-wrap"},[_c('b',[_vm._v(_vm._s(_vm.$t('Loads.OnLocationTime')))]),_vm._v(": "),_c('span',{style:({color: _vm.timeDiff > (_vm.hoursUntilDetention * 60 * 60) ? '#f44336' : '#4caf50'})},[_vm._v(" "+_vm._s(_vm.$root.showDuration(_vm.timeDiff))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }